<div class="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 backdrop-blur-sm" (click)="onClose()">
  <div class="relative w-full max-w-[400px] rounded-lg bg-white p-5 shadow-xl" (click)="$event.stopPropagation()">
    <button
      (click)="onClose()"
      class="absolute top-4 right-4 cursor-pointer text-gray-400 transition-colors hover:text-gray-600">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    </button>

    <div class="mt-2 flex flex-col items-center text-center">
      <h2 class="mb-4 text-xl font-bold text-gray-900" i18n="@@cancelPharmacyRequestTitle">Cancel Pharmacy Request</h2>

      <p class="mb-6 text-sm text-gray-500" [class]="isArabic() ? 'text-right' : 'text-left'">
        <span i18n="@@cancelPharmacyRequestMessage">
          Are you sure you want to cancel pharmacy registration request Request ID: ?
        </span>
        <span>
          <span i18n="@@requestId">Request ID:</span>
          {{ pharmacyRequestId() }}
        </span>

        <span class="text-xs text-red-600" i18n="@@undoneAction">This action cannot be undone.</span>
      </p>

      @if (errorCancel()) {
        <div class="my-6 w-full">
          <app-error [apiError]="errorCancel()" />
        </div>
      }

      <div class="flex w-full items-center justify-end gap-3">
        <button
          (click)="onClose()"
          class="border-primary text-primary hover-bg-primary-10 min-w-[100px] cursor-pointer rounded-[6px] border px-4 py-2 text-sm font-medium transition-colors"
          i18n="@@cancel">
          Cancel
        </button>
        <button
          (click)="onConfirm()"
          class="bg-primary hover-bg-primary-hover min-w-[100px] cursor-pointer rounded-[6px] px-4 py-2 text-sm font-medium text-white transition-colors">
          @if (loadingCancel()) {
            <span i18n="@@loading">loading...</span>
          } @else {
            <span i18n="@@save">Confirm</span>
          }
        </button>
      </div>
    </div>
  </div>
</div>
